<script setup>
import { defineProps, ref, onMounted , computed} from "vue";
import Locator from "@/components/frontend/Locator.vue";
import LocationsList from "@/components/frontend/LocationsList.vue";
import Modal from "@/components/frontend/ui/Modal.vue";

const props = defineProps({
  storeApiUrl: {
    type: String,
    required: true,
  },
});

const isLoading = ref(false);
const stores = ref([]);
const fetchStores = async (coordonnates = null) => {
  isLoading.value = true;
  try {
    const endPoint = props.storeApiUrl + (coordonnates
      ? `&filter[located_near]=${coordonnates.latitude},${coordonnates.longitude}`
      : "");
    const response = await fetch(endPoint);
    const { data: storesResponse } = await response.json();
    stores.value = storesResponse
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};
const onLocalized = (location) => {
  fetchStores(location);
};

const locations = computed(() => {
  return stores.value.map((store) => { return store.location })
})


const selectedStore = ref(null);
const onSelectLocation = (location) => {
  selectedStore.value = stores.value.find((store) => store.location.id === location.id);
};


onMounted(() => {
  fetchStores();
});

</script>

<template>
  <div class="container-xl p-0">
    <LocationsList
      :locations="locations"
      @selectLocation="onSelectLocation"
    ></LocationsList>

    <Locator
      class="mt-5"
      @localized="onLocalized"
    ></Locator>

    <div v-if="isLoading">
      {{ $t('Loading…') }}
    </div>
    <div class="row mt-5">
      <div v-for="store in stores" :key="store.id" class="col-sm-6 col-lg-4 mb-1 mb-sm-2 mb-md-4" style="font-size: 0.9em">
        <div class="bg-white d-flex align-items-center p-3 border-light">
          <a :href="store.page_url"
             class="" style="text-decoration: none">
            <h6 class="mb-0 font-weight-bold">{{ store.name }}</h6>
            <address v-if="store.location" class="text-muted my-1">
              <strong>{{ store.location.name }}</strong><br>
              {{ store.location.address }} - {{ store.location.country_name }}
            </address>
            <div v-if="store.distance" class="text-muted mt-1">
              {{ $t('Distance') }}: <strong>{{ store.distance }} km</strong>
            </div>
          </a>
        </div>
      </div>
    </div>

    <Modal
      title="selectedStore.name"
      size="lg"
      :show="!! selectedStore"
      @hidePrevented="selectedStore = null"
      @hide="selectedStore = null">
      <template #header>
        <div class="modal-header" v-if="selectedStore">
          <div>
            <h4 class="modal-title">{{ selectedStore.name }}</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <div v-if="selectedStore">
        <div>
          <h5>{{ selectedStore.location.name }}</h5>
          <p class="">
            {{ selectedStore.location.address }} -
            <span class="text-uppercase">{{ selectedStore.location.country_name }}</span>
          </p>

        </div>
        <a :href="selectedStore.page_url" class="btn btn-primary">{{ $t('More information') }}</a>
      </div>
    </Modal>
  </div>

</template>